import { Injectable } from '@angular/core';
import { isEmptyField } from '../common-utils';

@Injectable({
  providedIn: 'root'
})
export class VlDateFormatService {

  constructor() { }

  getTodayAsModelDate(){
    let date = new Date();
    return this.getModelDateFromDate(date);
  }

  getModelDateFromDate(date: Date){
    if(date){
      let year = (date.getFullYear()).toString();
      let month = (((date.getMonth()+1)<10)?"0"+(date.getMonth()+1):date.getMonth()+1).toString();
      let day = ((date.getDate() < 10)?"0"+date.getDate():date.getDate()).toString();
      return year+month+day;
    } else return null;
  }

  getModelFormatDateFromDate(date: Date){
    if(date){
      let year = (date.getFullYear()).toString();
      let month = (((date.getMonth()+1)<10)?"0"+(date.getMonth()+1):date.getMonth()+1).toString();
      let day = ((date.getDate() < 10)?"0"+date.getDate():date.getDate()).toString();
      return month+'-'+day+'-'+year;
    } else return null;
  }
  
  generateDateTimeString(date: any, time: any) {
    return this.prefixZero(date.day) + '-' + this.prefixZero(date.month) + '-' + date.year + ' ' + time.hour + ':' + time.minute;
  }

  prefixZero(value: any) {
    return value < 10 ? '0' + value.toString() : value;
  }
  
  formatFromNewDate(date: Date, format?: string) {
    const defaultFormat = 'yyyymmdd';
    if (!format) {
      format = defaultFormat;
    }
    let dateObject: any = {};
    dateObject.year = date.getFullYear();
    dateObject.month = this.prefixZero(date.getMonth() + 1);
    dateObject.day = this.prefixZero(date.getDate());
    return this.formatDateObjectToString(dateObject, format);
  }
  //yyyymmdd   ddmmyyyy
  dateToString(date:string){
    let sdf = '/'
    let a= date.slice(6,8)+ sdf+date.slice(4,6)+sdf+date.slice(0,4);
    return a;
  }

  getDateInFormatFromTimeStamp(timestamp: number){
    let date = this.getModelFormatDateFromDate(new Date(timestamp));
    return date;
  }

  formatToNewDate(dateString: any, format?: string) {
    if (isEmptyField(dateString)) {
      return;
    }
    const defaultFormat = 'yyyymmdd';
    if (!format) {
      format = defaultFormat;
    }
    const dateObject = this.formatStringToDateObject(dateString, format);
    dateObject.month = parseInt(dateObject.month) - 1;
    return new Date(dateObject.year, dateObject.month, dateObject.day);
  }

  formatStringToDateObject(dateString: string, format: string) {
    let dateObject: any = {
      day: 1,
      month: 1,
      year: new Date().getFullYear()
    };
    const dateStringArray = dateString.split('');
    const formatArray = format.split('');
    let graceIndex = -1;
    for (let index = 0; index < formatArray.length ; index ++) {
      const dateString = formatArray[index];
      if (index < graceIndex) { continue; }
      if (dateString === 'd' || dateString === 'm') {
        graceIndex = index + 2;
        dateObject[dateString === 'd' ? 'day' : 'month'] = dateStringArray[index] + dateStringArray[index + 1];
      } else if (dateString === 'y') {
        graceIndex = index + 4;
        dateObject.year = dateStringArray[index] + dateStringArray[index + 1] + dateStringArray[index + 2] + dateStringArray[index + 3];
      }
    }
    return dateObject;
  }

  formatDateObjectToString(dateObject: any, format: string) {
    let date = '';
    const formatArray = format.split('');
    let graceIndex = -1;
    for (let index = 0; index < formatArray.length ; index ++) {
      const dateString = formatArray[index];
      if (index < graceIndex) { continue; }
      if (dateString === 'd' || dateString === 'm') {
        graceIndex = index + 2;
        date = date + (dateString === 'd' ? dateObject.day : dateObject.month);
      } else if (dateString === 'y') {
        graceIndex = index + 4;
        date = date + dateObject.year;
      }
    }
    return date;
  }

  formatDateandTime(date:any){
    let data = date+'Z';
    let dateString = Date.parse(data);
    let formatdateString = new Date();
    formatdateString.setTime(dateString)
    let formatteddate = new Date(formatdateString).toLocaleString("en-US");
    let changeddate = formatteddate.split(',');
    let dateformat:string = ""
    for(let data of changeddate[0].split('/')){
      // Use data directly, applying padStart as needed during concatenation
      dateformat += (dateformat ? '-' : '') + (data.length === 1 ? data.padStart(2, '0') : data);
    }
    let timeformat = this.TimeConversion(changeddate[1]).trim();
    return [dateformat.substring(1),timeformat]; 
  }

  TimeConversion(time:any){
    if(time.includes('PM')){
      let changedtime:any;
      if(Number(time.split(':')[0]) != 12){
        changedtime = Number(time.split(':')[0])+ 12;
      }else if(Number(time.split(':')[0]) == 12){
        changedtime = '12';
      }
      return changedtime.toString()+':'+time.split(':')[1];
    }else{
      let changedtime:any;
      if(time.includes('AM')){
        if(Number(time.split(':')[0]) != 12){
          changedtime = Number(time.split(':')[0]);
        }else if(Number(time.split(':')[0]) == 12){
          changedtime = '00';
        }
      }
      return changedtime.toString()+':'+time.split(':')[1];
    }
  }
}
